/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactInputFromJSON, ContactInputToJSON, } from './ContactInput';
import { ProducerCustomerFromJSON, ProducerCustomerToJSON, } from './ProducerCustomer';
import { ProducerPowerFromJSON, ProducerPowerToJSON, } from './ProducerPower';
/**
 * @export
 */
export const ProducerEnergySourceEnum = {
    SolarPowerPlantsPhotovoltaicPowerPlants: 'Solar power plants (photovoltaic power plants)',
    WindPowerPlants: 'Wind power plants',
    HydroelectricPowerPlants: 'Hydroelectric power plants',
    GeothermalPowerPlants: 'Geothermal power plants',
    OceanPowerPlants: 'Ocean power plants',
    BiomassPowerPlants: 'Biomass power plants',
    ThermalSolarPowerPlants: 'Thermal solar power plants',
    HydrogenPowerPlants: 'Hydrogen power plants'
};
/**
 * @export
 */
export const ProducerErpRegionEnum = {
    North: 'North',
    South: 'South',
    West: 'West',
    GoldenSands: 'Golden Sands'
};
/**
 * @export
 */
export const ProducerDevelopmentStageEnum = {
    Operating: 'operating',
    Construction: 'construction',
    Research: 'research'
};
/**
 * Check if a given object implements the Producer interface.
 */
export function instanceOfProducer(value) {
    return true;
}
export function ProducerFromJSON(json) {
    return ProducerFromJSONTyped(json, false);
}
export function ProducerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'contacts': json['contacts'] == null ? undefined : (json['contacts'].map(ContactInputFromJSON)),
        'customer': json['customer'] == null ? undefined : ProducerCustomerFromJSON(json['customer']),
        'energySource': json['energy_source'] == null ? undefined : json['energy_source'],
        'power': json['power'] == null ? undefined : ProducerPowerFromJSON(json['power']),
        'exploitationDate': json['exploitation_date'] == null ? undefined : (new Date(json['exploitation_date'])),
        'erpRegion': json['erp_region'] == null ? undefined : json['erp_region'],
        'hasPreferentialPriceAgreement': json['has_preferential_price_agreement'] == null ? undefined : json['has_preferential_price_agreement'],
        'developmentStage': json['development_stage'] == null ? undefined : json['development_stage'],
    };
}
export function ProducerToJSON(json) {
    return ProducerToJSONTyped(json, false);
}
export function ProducerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'contacts': value['contacts'] == null ? undefined : (value['contacts'].map(ContactInputToJSON)),
        'customer': ProducerCustomerToJSON(value['customer']),
        'energy_source': value['energySource'],
        'power': ProducerPowerToJSON(value['power']),
        'exploitation_date': value['exploitationDate'] == null ? undefined : ((value['exploitationDate']).toISOString().substring(0, 10)),
        'erp_region': value['erpRegion'],
        'has_preferential_price_agreement': value['hasPreferentialPriceAgreement'],
        'development_stage': value['developmentStage'],
    };
}
